// extracted by mini-css-extract-plugin
export default {"video-section":"f_l d-flex","video-section--header":"f_m","video-section__frame":"f_n ml-3"};